<template>
  <div>
    <div>
      <div class="title_1_step text-center">1. Selecciona tu horario</div>

      <div class="container_course_selected">
        <LanguageFlag
          v-bind:imageSource="lastCourse.language_id"
        ></LanguageFlag>
        <div class="content_course_selected">
          <div class="course_name">
            {{ lastCourse.language_name.toUpperCase() }}
          </div>
          <div class="course_nivel">
            <div
              class="level_selected_course"
              v-if="lastCourse.course_code.length <= 4"
            >
              {{ lastCourse.course_code }}
            </div>
            <div
              class="text_selected_course"
              :style="
                lastCourse.course_code.length <= 4 ? '' : 'margin-left:0px'
              "
            >
              {{ lastCourse.course_name }}
            </div>
          </div>
        </div>
        <!-- Slots (cupos) disponibles: {{ slots }} -->
      </div>
      <div class="shceduler" v-show="showScheduleContinuity">
        Puedes continuar con tu horario o realizar los cambios que desees.
      </div>
      <div class="accordion_schedules">
        <v-expansion-panels accordion v-model="expended_value">
          <v-expansion-panel
            class="espansion_panel"
            @change="changePanel(1)"
            v-show="showScheduleContinuity"
          >
            <v-expansion-panel-header class="expansion_panel_schedules">
              <span class="solid_black_text">Continuar en mi horario</span>
              <template v-slot:actions>
                <div :class="returnIconAccordion(1)"></div>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="espancion_content">
              <div class="stepper_loading_container" v-if="!isLoad">
                <v-flex d-flex flex-md-row flex-lg-row>
                  <v-flex d-flex flex-column>
                    <v-skeleton-loader
                      ref="skeleton"
                      type="button"
                      class="mx-auto pa-0 mb-4"
                      :tile="true"
                      :boilerplate="false"
                      style="width:95%"
                      height="45"
                    >
                    </v-skeleton-loader>

                    <v-skeleton-loader
                      ref="skeleton"
                      type="button"
                      class="mx-auto pa-0 mb-4"
                      :tile="true"
                      :boilerplate="false"
                      style="width:95%"
                      height="45"
                    >
                    </v-skeleton-loader>

                    <v-skeleton-loader
                      ref="skeleton"
                      type="button"
                      class="mx-auto pa-0 mb-4"
                      :tile="true"
                      :boilerplate="false"
                      style="width:95%"
                      height="45"
                    >
                    </v-skeleton-loader>
                  </v-flex>
                  <v-flex d-flex flex-column>
                    <v-skeleton-loader
                      ref="skeleton"
                      type="button"
                      class="mx-auto pa-0 mb-4"
                      :tile="true"
                      :boilerplate="false"
                      style="width:95%"
                      height="45"
                    >
                    </v-skeleton-loader>

                    <v-skeleton-loader
                      ref="skeleton"
                      type="button"
                      class="mx-auto pa-0 mb-4"
                      :tile="true"
                      :boilerplate="false"
                      style="width:95%"
                      height="45"
                    >
                    </v-skeleton-loader>

                    <v-skeleton-loader
                      ref="skeleton"
                      type="button"
                      class="mx-auto pa-0 mb-4"
                      :tile="true"
                      :boilerplate="false"
                      style="width:95%"
                      height="45"
                    >
                    </v-skeleton-loader>
                  </v-flex>
                </v-flex>
              </div>
              <v-flex
                d-flex
                class="continous_schudle"
                flex-md-row
                flex-lg-row
                style="width:100%"
                v-else
              >
                <v-flex d-flex flex-column>
                  <v-flex d-flex flex-column mb-5>
                    <v-flex d-flex flex-column class="lower_content"
                      >Sede</v-flex
                    >
                    <v-flex d-flex flex-column class="light_black_text">{{
                      this.defaultSection.campus_name
                        ? this.defaultSection.campus_name
                        : " - "
                    }}</v-flex>
                  </v-flex>

                  <v-flex d-flex flex-column mb-5>
                    <v-flex d-flex flex-column class="lower_content"
                      >Frecuencia</v-flex
                    >
                    <v-flex d-flex flex-column class="light_black_text">{{
                      this.defaultSection.frequency
                        ? this.defaultSection.frequency
                        : " - "
                    }}</v-flex>
                  </v-flex>

                  <v-flex d-flex flex-column>
                    <v-flex d-flex flex-column class="lower_content"
                      >Fecha de inicio / fin</v-flex
                    >
                    <v-flex d-flex flex-column class="light_black_text">{{
                      this.defaultSection.start_end_date
                        ? this.defaultSection.start_end_date
                        : " - "
                    }}</v-flex>
                  </v-flex>
                </v-flex>

                <v-flex d-flex flex-column class="column_right">
                  <v-flex d-flex flex-column mb-5>
                    <v-flex d-flex flex-column class="lower_content"
                      >Modalidad</v-flex
                    >
                    <v-flex d-flex flex-column class="light_black_text">{{
                      this.defaultSection.modality_name
                        ? this.defaultSection.modality_name
                        : " - "
                    }}</v-flex>
                  </v-flex>

                  <v-flex d-flex flex-column mb-5>
                    <v-flex d-flex flex-column class="lower_content"
                      >Horario</v-flex
                    >
                    <v-flex d-flex flex-column class="light_black_text">{{
                      this.defaultSection.schedule
                        ? this.defaultSection.schedule
                        : " - "
                    }}</v-flex>
                  </v-flex>

                  <v-flex d-flex flex-column>
                    <v-flex d-flex flex-column class="lower_content"
                      >Grupo</v-flex
                    >
                    <v-flex d-flex flex-column class="light_black_text">{{
                      this.defaultSection.classroom
                        ? this.defaultSection.classroom
                        : " - "
                    }}</v-flex>
                  </v-flex>
                </v-flex>
              </v-flex>

              <v-col
                style="padding: 12px 0"
                class="margin_contents"
                v-if="defaultFreeDays.length > 0"
              >
                <div
                  class="container_book_selected"
                  style="margin-top:0;flex-direction:row;padding: 0px;background-color:white"
                >
                  <div class="icon_body">
                    <div class="icon_icon"></div>
                  </div>
                  <div class="text_body" v-if="defaultFreeDays.length == 1">
                    Sesión del curso distinta de la frecuencia regular:<br />{{
                      freeDaysFormated(defaultFreeDays)
                    }}
                  </div>
                  <div class="text_body" v-if="defaultFreeDays.length > 1">
                    Sesiones del curso distintas de la frecuencia regular:<br />{{
                      freeDaysFormated(defaultFreeDays)
                    }}
                  </div>
                </div>
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="espansion_panel" @change="changePanel(2)">
            <v-expansion-panel-header
              class="expansion_panel_schedules"
              v-show="showScheduleContinuity"
            >
              <span class="solid_black_text">Buscar otras opciones</span>
              <template v-slot:actions>
                <div :class="returnIconAccordion(2)"></div>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="espancion_content">
              <div class="select_sede">
                <v-radio-group
                  v-model="selectedSchedule.campus"
                  :mandatory="false"
                  style="width:100%"
                  row
                  @change="getModalities($event)"
                >
                  <div
                    class="radion_buttons"
                    v-for="(campus, index) in selectedSchedule.campusList"
                    :key="index"
                  >
                    <v-radio
                      color="#41424E"
                      :label="campus.campus_id"
                      :value="campus"
                    >
                      <template v-slot:label>
                        <div class="label_radio_button">
                          <div class="title_radio_button">
                            {{ campus.campus_name }}
                          </div>
                          <div class="body_radio_button">
                            {{
                              campus.campus_address ? campus.campus_address : ""
                            }}
                          </div>
                        </div>
                      </template>
                    </v-radio>
                  </div>
                </v-radio-group>
              </div>

              <div class="form_enrollment_course">
                <form>
                  <v-row dense>
                    <v-col cols="12" xs="12" sm="12" md="12" class="no_padding">
                      <v-select
                        :items="selectedSchedule.modalityList"
                        label="Modalidad"
                        filled
                        return-object
                        item-text="modality_name"
                        :cache-items="false"
                        v-model="selectedSchedule.modality"
                        :menu-props="{ bottom: true, offsetY: true }"
                        @change="getFrequency"
                        no-data-text="No hay datos. Selecciona una Sede"
                        :loading="modalityLoading"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="12" class="no_padding">
                      <v-select
                        :items="selectedSchedule.frequencyList"
                        label="Frecuencia"
                        filled
                        return-object
                        item-text="frequency_name"
                        v-model="selectedSchedule.frequency"
                        :menu-props="{ bottom: true, offsetY: true }"
                        @change="getSchedule"
                        no-data-text="No hay datos. Selecciona una Modalidad"
                        :loading="frequencyLoading"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="12" class="no_padding">
                      <v-select
                        :items="selectedSchedule.listSchedules"
                        label="Horario"
                        filled
                        return-object
                        item-text="schedule_name"
                        v-model="selectedSchedule.schedule"
                        :menu-props="{ bottom: true, offsetY: true }"
                        @change="getEndStartDate"
                        no-data-text="No hay datos. Selecciona una Frecuencia"
                        :loading="scheduleLoading"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="12" class="no_padding">
                      <v-select
                        :items="selectedSchedule.listOfDates"
                        label="Fecha Inicio/Fin"
                        filled
                        return-object
                        item-text="start_end_date_name"
                        v-model="selectedSchedule.date"
                        :menu-props="{ bottom: true, offsetY: true }"
                        @change="getSection"
                        no-data-text="No hay datos. Selecciona un Horario"
                        :loading="dateLoading"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" xs="12" sm="12" md="6" class="no_padding">
                      <v-select
                        v-if="
                          selectedSchedule.sectionList &&
                            selectedSchedule.sectionList.length > 1
                        "
                        :items="selectedSchedule.sectionList"
                        label="Grupo"
                        filled
                        return-object
                        item-text="classroom"
                        v-model="selectedSchedule.section"
                        :menu-props="{ bottom: true, offsetY: true }"
                        @change="setSection"
                        :loading="sectionLoading"
                      ></v-select>
                    </v-col>

                    <v-col
                      cols="12"
                      xs="12"
                      sm="12"
                      md="12"
                      class="no_padding"
                      v-if="selectedSchedule.freeDayList.length > 0"
                    >
                      <div
                        class="container_book_selected"
                        style="margin-top:0;flex-direction:row;padding: 0px;background-color:white"
                      >
                        <div class="icon_body">
                          <v-icon color="primary" small>info</v-icon>
                        </div>
                        <div
                          class="text_body"
                          v-if="selectedSchedule.freeDayList.length == 1"
                        >
                          Sesión del curso distinta de la frecuencia regular:<br />
                          {{ freeDaysFormated(selectedSchedule.freeDayList) }}
                        </div>
                        <div
                          class="text_body"
                          v-if="selectedSchedule.freeDayList.length > 1"
                        >
                          Sesiones del curso distintas de la frecuencia
                          regular:<br />
                          {{ freeDaysFormated(selectedSchedule.freeDayList) }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </form>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>

      <v-row v-if="courseAmount != null ? true : false" class="d-flex">
        <v-col cols="7" xs="7" sm="8" md="9" class="costo_curso"
          >Costo del curso</v-col
        >
        <v-col cols="5" xs="5" sm="4" md="3" class="costo_curso text-end"
          >S/ {{ this.courseAmount.toFixed(2) }}</v-col
        >
      </v-row>

      <div
        class="container_book_selected margin_contents"
        v-if="bookData != null && bookData.book_price != null"
      >
        <div class="title_adD_book">¿Quieres adquirir el libro?</div>

        <div
          class="body_adD_book"
          v-if="bookData.book_message && bookData.book_message != ''"
        >
          <div class="icon_body">
            <v-icon color="primary" small>info</v-icon>
          </div>
          <div class="text_body">
            <!-- Recuerda que estás pasando de Nivel Elemental a Preintermedio y es necesario que adquieras el libro de inglés para este módulo. -->
            {{ bookData.book_message }}
          </div>
        </div>

        <div class="select_book">
          <v-radio-group
            v-model="radiosWantBook"
            :mandatory="false"
            style="width:100%"
            row
            @change="handleBookSelection($event)"
          >
            <v-radio color="#41424E" label="Radio 1" value="1">
              <template v-slot:label>
                <div class="label_radio_button">Sí, quiero el libro</div>
              </template>
            </v-radio>
            <v-radio color="#41424E" label="Radio 2" value="0">
              <template v-slot:label>
                <div class="label_radio_button">No, ahora no</div>
              </template>
            </v-radio>
          </v-radio-group>
        </div>

        <div class="extra_text">
          {{ bookData.book_note }}
        </div>
      </div>

      <div class="accordion_schedules" v-if="showAddressBook">
        <div class="espancion_content">
          <div class="form_enrollment_address_book">
            <form>
              <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="12" class="no_padding">
                  <v-select
                    :items="selectedSchedule.addressBookList"
                    label="Dirección de envío del libro"
                    filled
                    return-object
                    item-text="name"
                    :cache-items="false"
                    v-model="selectedSchedule.addressBook"
                    :menu-props="{ bottom: true, offsetY: true }"
                    @change="selectAddressBook"
                    no-data-text="No hay datos."
                    :loading="isLoadingAddressBook"
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" class="no_padding" v-if="ifSelectHome">
                  <v-select
                    :items="selectedSchedule.listDistrict"
                    label="Distrito"
                    filled
                    return-object
                    item-text="Value"
                    :cache-items="false"
                    v-model="selectedSchedule.district"
                    :menu-props="{ bottom: true, offsetY: true }"
                    no-data-text="No hay datos."
                    :loading="districtLoading"
                    required
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" class="no_padding" v-if="ifSelectHome">
                  <v-text-field
                    v-model="selectedSchedule.addressHome"
                    label="Escribe tu dirección"
                    filled
                    :rules="[rules.required, rules.maxLength]"
                  ></v-text-field>
                </v-col>
              </v-row>
            </form>
          </div>
        </div>
      </div>

      <v-row
        style="margin: 30px 0 0 0"
        class="d-flex"
        v-if="bookData != null && bookData.book_price != null"
      >
        <v-col cols="8" xs="8" sm="8" md="9" class="costo_curso">
          {{ bookData.book_text }}
        </v-col>
        <v-col cols="4" xs="4" sm="4" md="3" class="costo_curso text-end">
          {{ bookData.book_currency + " " + bookData.book_price }}
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="12"
          class="text-start responsive_content_checbox"
        >
          <v-checkbox
            v-model="checkBoxTerminos"
            class="show_responsive_checbox"
          ></v-checkbox>
          <div class="accept_terms">
            Acepto los
            <span
              @click="modalTerms = true"
              style="color:#00A8E1;margin-left:4px;cursor:pointer"
              >términos y condiciones</span
            >
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="12"
          class="text-end responsive_content_checbox"
        >
          <v-checkbox
            v-model="checkBoxReglamento"
            class="show_responsive_checbox"
          ></v-checkbox>
          <div class="accept_terms">
            <span>Acepto haber leído las</span>
            <a
              href="https://campusvirtual.up.edu.pe/pdf/cidup-reglamento-academico-administrativo-enero-diciembre-2021.pdf"
              target="_blank"
            >
             Normas académicas y Administrativas</a
            >
            <span>y la</span>
            <a
              href="https://campusvirtual.up.edu.pe/pdf/hoja-informativa-sobre-normas-administrativas.pdf"
              target="_blank"
              >Hoja Informativa</a
            >
          </div>
        </v-col>
      </v-row>

      <div class="blue_container pa-4 mb-10">
        <v-col cols="12" xs="12" sm="12" md="12" class="no_padding pa-0">
          <div
            class="container_book_selected pa-0 mt-0"
            style="flex-direction:row;"
          >
            <div class="icon_body">
              <v-icon color="primary" small>info</v-icon>
            </div>
            <div class="text_freedays">
              En el siguiente paso, "Resumen", podrás visualizar el monto total
              a pagar. Además, de los descuentos, en caso apliquen.
            </div>
          </div>
        </v-col>
      </div>

      <v-row>
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="12"
          class="text-end d-flex justify-end align-center"
        >
          <div class="return_step_top">
            <span class="selected" @click="goToBack()">
              <v-icon style="cursor:pointer">keyboard_arrow_left</v-icon
              >Anterior
            </span>
          </div>

          <v-btn
            :disabled="disableContinue(1)"
            color="primary"
            class="btn-basic uppercase"
            @click="complete()"
            >Continuar</v-btn
          >
        </v-col>
      </v-row>
    </div>
    <v-dialog v-model="modalTerms" persistent content-class="modalTerms">
      <v-card>
        <v-card-title class="titulo__dialog_img">
          <div class="flex-grow-1"></div>
          <v-btn icon @click="modalTerms = false" class="bottom-white">
            <v-icon class="iconColor">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="title__dialog">Términos y condiciones</div>
        <v-card-text class="terms">
          <vue-perfect-scrollbar
            class="drawer-menu--scroll"
            :settings="scrollSettings"
            @ps-y-reach-end="enableButton()"
          >
            <ul>
              <li v-for="(item, index) in listTerms" :key="index">
                <span class="text_li">{{ item }}</span>
              </li>
            </ul>
          </vue-perfect-scrollbar>
        </v-card-text>
        <v-card-actions
          style="display:flex;justify-content: center;margin: 0px 0;padding: 10px 0px 25px 0;"
        >
          <button
            class="btn--primary"
            style="max-width: 240px !important"
            v-bind:class="verifyLocked()"
            @click="
              modalTerms = false;
              checkBoxTerminos = true;
              read = false;
            "
          >
            Ya lo leí
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogNoHorario"
      persistent
      content-class="dialogNoHorario"
    >
      <v-card>
        <v-card-title>
          <div class="flex-grow-1"></div>
          <v-btn icon @click="dialogNoHorario = false">
            <v-icon class="iconColor">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="display: flex;justify-content: center;">
          <div class="dialogNoHorario__no-schedule"></div>
        </v-card-text>
        <v-card-text
          style="display: flex;justify-content: center;padding:53px 0"
        >
          <div class="dialogNoHorario__no-schedule-img"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../axios-auth";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapState, mapMutations, mapActions } from "vuex";
import jwt from "jwt-simple";
import LanguageFlag from "@/components/LanguageFlag.vue";

export default {
  name: "SelectSchedule",
  components: {
    VuePerfectScrollbar,
    LanguageFlag
  },
  props: ["step", "isMinor"],
  data() {
    return {
      isLoad: false,
      scrollSettings: {
        maxScrollbarLength: 160
      },
      listTerms: [
        "De conformidad con la Ley N° 29733 (en adelante, la Ley) y el Decreto Supremo N° 003-2013- JUS (en adelante, el Reglamento), la Universidad del Pacífico (en adelante la Universidad), le informa al usuario que sus datos personales que obran en poder de la Universidad y a los cuales se accede a través de esta aplicación, serán objeto de flujo transfronterizo a los países de Estados Unidos y Chile, con el propósito de procesar los datos y que la aplicación funcione adecuadamente.",
        "La Universidad declara que sus datos personales cuentan con todas las medidas de seguridad requeridas para su correcto tratamiento.",
        "Asimismo, el usuario autoriza que las imágenes en fotografía o video que opte por cargar en esta aplicación, también serán objeto de flujo transfronterizo. La Universidad procurará que estos no se vean afectados por cualquier uso indebido.",
        "En caso que el titular de los datos personales sea menor de edad entre catorce y dieciocho años, declara que lo descrito en este documento es comprensible; y, en función a ello, otorga su consentimiento para el flujo transfronterizo de sus datos personales, de conformidad con las finalidades descritas anteriormente.",
        "La Universidad informa a sus usuarios que sus datos personales serán conservados mientras sean necesarios para cumplir con las finalidades para las cuales se recopilaron.",
        "En caso que el usuario desee ejercer sus derechos de revocatoria de consentimiento, modificación o cualquier otro que se encuentra contemplado en la legislación de la materia, podrá recurrir a la oficina de Data Intelligence, la misma que se encuentra ubicada en Jirón Luis Sánchez Cerro N° 2141, distrito de Jesús María o escribir a revocatoria.alumnos.egresados@up.edu.pe."
      ],
      modalTerms: false,
      read: false,
      dialogNoHorario: false,

      //accordion
      expended_value: -1,
      showSelectedSchedule: true,
      user: null,

      bookData: null,
      lastCourse: null,
      defaultFreeDays: [],
      quotas: [],
      courseAmount: null,
      slots: 0,
      slots2: 0,
      typeOfSchedule: 0,

      modalityLoading: false,
      frequencyLoading: false,
      scheduleLoading: false,
      dateLoading: false,
      sectionLoading: false,

      selectedSchedule: {
        campusList: [],
        campus: null,
        modalityList: [],
        modality: null,
        frequencyList: [],
        frequency: null,
        listSchedules: [],
        schedule: null,
        listOfDates: [],
        date: null,
        sectionList: [],
        section: null,
        freeDayList: [],
        addressBookList: [
          /*{
            id: 'LOCAL',
            name: "Local"
          },*/
          {
            id: 'DOMICILIO',
            name: "Domicilio"
          }
        ],
        addressBook: null,
        addressHome: null,
        listDistrict: [],
        district: null,
      },

      radiosWantBook: 0,
      checkBoxTerminos: false,
      checkBoxReglamento: false,
      otherDiscounts: [],

      showAddressBook: false,
      ifSelectHome: false,
      districtLoading: false,
      isLoadingAddressBook: false,
      rules: {
        required: value => !!value || "Campo obligatorio.",
        maxLength: value => (value && value.length <= 100) || "Máximo 100 caracteres"
      }
    };
  },

  async created() {
    this.user = this.$store.state.usuario;

    if (localStorage.lastCourse) {
      let course = localStorage.getItem("lastCourse");
      this.lastCourse = jwt.decode(course, this.secretKeyJwt);

      localStorage.removeItem("lastCourse");

      this.addPropToDefaultSection({
        course_name: this.lastCourse.course_name,
        course_code: this.lastCourse.course_code
      });
    } else {
      this.$router.push("/principal");
    }
    this.init();
  },
  mounted() {
    this.enviarEvento();
  },
  methods: {
    ...mapMutations(["addPropToDefaultSection"]),
    ...mapActions([
      "addOthersDiscounts",
      "addDiscounts",
      "addWantBook",
      "prepareDiscounts",
      "calculateGroosDiscount"
    ]),
    enviarEvento() {
      if (typeof window.gtag === 'function') {
        window.gtag('event', '1 - Selección de horario', {
          'event_category': 'Matricula'
        });
      }
    },
    goToBack() {
      if (this.isMinor) {
        this.goToStep(1);
      } else {
        this.$router.push("/principal");
      }
    },
    async init() {
      this.isLoad = false;
      this.defaultFreeDays = [];
      this.courseAmount = null;
      this.lastSchedule = await this.getLastSchedule();
      this.selectedSchedule.campusList = await this.getCampusList();
      this.addPropToDefaultSection({ classroom: null });
      this.addPropToDefaultSection({ start_end_date: null });
      this.addPropToDefaultSection({ section_id: null });
      this.addPropToDefaultSection({ book: null });
      if (this.lastSchedule) {
        if (this.lastSchedule.book && this.lastSchedule.book.book_id) {
          this.bookData = this.lastSchedule.book;
          this.addPropToDefaultSection({ book: this.lastSchedule.book });
        }

        if (
          this.lastSchedule.default_section &&
          this.lastSchedule.default_section.length > 0
        ) {
          this.typeOfSchedule = 1;

          this.addPropToDefaultSection(this.lastSchedule.default_section[0]);

          if (
            this.defaultSection.free_days &&
            this.defaultSection.free_days.length > 0
          ) {
            this.defaultFreeDays = this.defaultSection.free_days;
          }

          if (this.defaultSection.course_amount) {
            this.courseAmount = this.defaultSection.course_amount;
          }

          if (this.defaultSection.slots) {
            this.slots = this.defaultSection.slots;
          }

          if (this.defaultSection.discounts) {
            this.addDiscounts(this.defaultSection.discounts);
          }
          if (this.defaultSection.other_discounts) {
            this.otherDiscounts = this.defaultSection.other_discounts;
            this.addOthersDiscounts(this.otherDiscounts);
          }
          this.typeOfSchedule = 1;
          this.isLoad = true;
        } else {
          this.typeOfSchedule = 2;

          this.showSelectedSchedule = false;
          this.expended_value = 1;

          this.addPropToDefaultSection({ section_id: null });
        }
      }
      this.$emit("loading", false);
    },
    async getLastSchedule() {
      let res = await axios({
        method: "post",
        url: `users/academic-offer/`,
        data: {
          course_id: this.$route.params.course_id,
          student_type: this.lastCourse.student_type
        },
        headers: {
          Authorization: "Token " + this.user.token
        }
      });

      let data = res.data;
      return data;
    },

    async getCampusList() {
      let res = await axios.get(`users/campus/`, {
        headers: { Authorization: "Token " + this.user.token }
      });
      let data = res.data;
      data.sort((a, b) => (a.campus_name > b.campus_name ? 1 : -1));
      return data;
    },

    async getModalities(campus) {
      this.modalityLoading = true;
      this.selectedSchedule.modality = null;
      this.selectedSchedule.modalityList = [];
      this.selectedSchedule.freeDayList = [];
      this.courseAmount = null;
      this.addPropToDefaultSection({ section_id: null });
      this.addPropToDefaultSection({ campus: campus });
      this.addPropToDefaultSection({ campus_name: campus.campus_name });

      let res = await axios.get(`users/campus/${campus.campus_id}/modality/`, {
        headers: { Authorization: "Token " + this.user.token }
      });
      let data = res.data;
      this.selectedSchedule.modalityList = data;

      this.modalityLoading = false;

      if (!this.selectedSchedule.modalityList.length) {
        this.dialogNoHorario = true;
      }
    },
    async getFrequency() {
      this.frequencyLoading = true;
      this.selectedSchedule.frequency = null;
      let res = await axios.get(
        `users/campus/${this.selectedSchedule.campus.campus_id}/modality/${this.selectedSchedule.modality.modality_id}/frequency/`,
        { headers: { Authorization: "Token " + this.user.token } }
      );
      let data = res.data;
      this.selectedSchedule.frequencyList = data;

      this.frequencyLoading = false;

      if (!this.selectedSchedule.frequencyList.length) {
        this.dialogNoHorario = true;
      }
    },
    async getSchedule() {
      this.scheduleLoading = true;
      this.selectedSchedule.schedule = null;
      let res = await axios.get(
        `users/campus/${this.selectedSchedule.campus.campus_id}/modality/${this.selectedSchedule.modality.modality_id}/frequency/${this.selectedSchedule.frequency.frequency_id}/schedule/`,
        {
          headers: { Authorization: "Token " + this.user.token }
        }
      );
      let data = res.data;
      this.selectedSchedule.listSchedules = data;
      this.scheduleLoading = false;

      if (!this.selectedSchedule.listSchedules.length) {
        this.dialogNoHorario = true;
      }
    },
    async getEndStartDate() {
      this.dateLoading = true;
      this.selectedSchedule.date = null;
      let res = await axios.get(
        `users/campus/${this.selectedSchedule.campus.campus_id}/modality/${this.selectedSchedule.modality.modality_id}/frequency/${this.selectedSchedule.frequency.frequency_id}/schedule/${this.selectedSchedule.schedule.schedule_id}/start-end-date/`,
        { headers: { Authorization: "Token " + this.user.token } }
      );
      let data = res.data;
      this.selectedSchedule.listOfDates = data;
      this.dateLoading = false;

      if (!this.selectedSchedule.listOfDates.length) {
        this.dialogNoHorario = true;
      }
    },

    async getSection() {
      this.selectedSchedule.section = null;
      this.otherDiscounts = [];
      let res = await axios.get(
        `users/campus/${this.selectedSchedule.campus.campus_id}/modality/${this.selectedSchedule.modality.modality_id}/frequency/${this.selectedSchedule.frequency.frequency_id}/schedule/${this.selectedSchedule.schedule.schedule_id}/start-end-date/${this.selectedSchedule.date.start_end_date_id}/`,
        { headers: { Authorization: "Token " + this.user.token } }
      );
      let data = res.data;

      if (data) {
        this.addPropToDefaultSection({ section_id: null });
        this.addPropToDefaultSection({ classroom: null });
        this.addPropToDefaultSection({ course_amount: null });
        this.addPropToDefaultSection({ free_days: null });
        this.addPropToDefaultSection({ quotas: null });
        if (data.sections && data.sections.length > 0) {
          this.selectedSchedule.sectionList = data.sections;

          if (this.selectedSchedule.sectionList.length == 1) {
            this.addPropToDefaultSection({
              section_id: this.selectedSchedule.sectionList[0].section_id
            });
            this.addPropToDefaultSection({
              classroom: this.selectedSchedule.sectionList[0].classroom
            });
            this.selectedSchedule.section = this.selectedSchedule.sectionList[0];

            this.courseAmount = this.selectedSchedule.section.course_amount;
            this.addPropToDefaultSection({ course_amount: this.courseAmount });
          }
        } else {
          this.dialogNoHorario = true;
        }

        this.addPropToDefaultSection({ free_days: null });

        if (data.free_days) {
          this.selectedSchedule.freeDayList = data.free_days;
          this.addPropToDefaultSection({
            free_days: this.selectedSchedule.freeDayList
          });
        }
        if (data.quotas && data.quotas.length > 0) {
          this.quotas = data.quotas;
          this.addPropToDefaultSection({ quotas: this.quotas });
        }
        if (data.other_discounts) {
          this.otherDiscounts = data.other_discounts;
          //this.addPropToDefaultSection({other_discounts: data.other_discounts});
        }
        if (data.discounts) {
          this.addDiscounts(data.discounts);

          this.addPropToDefaultSection({ discounts: data.discounts });
        } else {
          this.addPropToDefaultSection({ discounts: null });
        }
      }
    },

    async validateSection(sectionId) {
      let res = await axios.get(`users/section-validation/${sectionId}/`, {
        headers: { Authorization: "Token " + this.user.token }
      });
      let data = res.data;

      if (data != null && data.slots) this.slots2 = data.slots;
    },

    setSection() {
      this.addPropToDefaultSection({
        section_id: this.selectedSchedule.section.section_id
      });
      this.courseAmount = this.selectedSchedule.section.course_amount;
      this.addPropToDefaultSection({ course_amount: this.courseAmount });
      this.addPropToDefaultSection({
        classroom: this.selectedSchedule.section.classroom
      });
    },

    returnIconAccordion(posicion) {
      if (this.expended_value > -1) {
        this.showSelectedSchedule = false;
      }
      if (posicion == 1) {
        if (this.expended_value == 0) {
          return "blue_check";
        }
        if (!this.showSelectedSchedule && this.expended_value != 0) {
          return "gray_check";
        } else if (this.showSelectedSchedule) {
          return "blue_check";
        }
      }
      if (posicion == 2) {
        if (this.expended_value == 1) {
          return "blue_check";
        } else return "gray_check";
      }
    },

    changePanel(indice) {
      this.otherDiscounts = [];
      this.addDiscounts(null);

      if (this.defaultSection != null && indice == 1) {
        this.init();
      } else {
        this.courseAmount = null;
        this.addPropToDefaultSection({ section_id: null });
        this.selectedSchedule.modalityList = [];
      }
    },
    enableButton() {
      this.read = true;
    },
    verifyLocked() {
      return this.read ? "" : "locked_button";
    },
    disableContinue() {
      if (!this.defaultSection || !this.defaultSection.section_id) return true;

      const isBookRequired = this.bookData != null && !this.radiosWantBook;
      const isAddressRequired = this.radiosWantBook == 1 && !this.selectedSchedule.addressBook;
      const isHomeAddressRequired = this.selectedSchedule.addressBook && this.selectedSchedule.addressBook.id == 'DOMICILIO' && (this.rules.required(this.selectedSchedule.addressHome) !== true || this.rules.maxLength(this.selectedSchedule.addressHome) !== true);
      const isDistrictRequired = this.selectedSchedule.addressBook && this.selectedSchedule.addressBook.id == 'DOMICILIO' && (this.rules.required(this.selectedSchedule.district) !== true);

      if (
      !this.checkBoxTerminos ||
      !this.checkBoxReglamento ||
      isBookRequired ||
      isAddressRequired ||
      isHomeAddressRequired ||
      isDistrictRequired
      ) {
      return true;
      }

      return false;
    },
    async complete() {
      await this.validateSection(this.defaultSection.section_id);

      if (this.slots2 > 0) {
        if (
          this.selectedSchedule.section &&
          this.selectedSchedule.section.section_id != null
        ) {
          this.addPropToDefaultSection({
            modality_name: this.selectedSchedule.modality.modality_name
          });
          this.addPropToDefaultSection({
            frequency: this.selectedSchedule.frequency.frequency_name
          });
          this.addPropToDefaultSection({
            schedule: this.selectedSchedule.schedule.schedule_name
          });
          this.addPropToDefaultSection({
            start_end_date: this.selectedSchedule.date.start_end_date_name
          });
          this.addPropToDefaultSection({
            campus_address: this.selectedSchedule.campus.campus_address
          });

          if (this.radiosWantBook == 1) {
            this.addPropToDefaultSection({
              method_address_book: this.selectedSchedule.addressBook?.id || null
            });
            this.addPropToDefaultSection({
              address_book: this.selectedSchedule.addressHome || this.selectedSchedule.addressBookList[0].id
            });
            this.addPropToDefaultSection({
              district_id: this.selectedSchedule.district?.Key || 0
            });
          }

          if (this.radiosWantBook == 0) {
            this.addPropToDefaultSection({
              method_address_book: null
            });
            this.addPropToDefaultSection({
              district_id: null
            });
            this.addPropToDefaultSection({
              address_book: null
            });
          }
        }
        this.addPropToDefaultSection({
          curriculum_id: this.lastCourse.curriculum_id
        });

        this.goToStep(2);
        if (this.isMinor) {
          this.goToStep(3);
        } else {
          this.goToStep(2);
        }
      } else {
        this.dialogNoHorario = true;
      }
    },
    goToStep(n) {
      // if (this.disableContinue()) {
      //   return;
      // }
      this.addPropToDefaultSection({ other_discounts: this.otherDiscounts });
      this.addPropToDefaultSection({ book_purchase: this.radiosWantBook });

      this.addOthersDiscounts(this.otherDiscounts);
      this.addWantBook(this.radiosWantBook);
      this.prepareDiscounts();
      this.calculateGroosDiscount({
        course: this.courseAmount,
        book: this.bookData ? this.bookData.book_price : 0
      });

      this.$emit("goToStep", n);
    },

    freeDaysFormated(daysList) {
      let daysArray = daysList.map(dayFree => {
        return (
          dayFree.day +
          " " +
          dayFree.date +
          " " +
          dayFree.start_hour +
          " - " +
          dayFree.end_hour
        );
      });

      return daysArray.join(", ");
    },

    async handleBookSelection(event) {

      this.ifSelectHome = false;

      // SI QUIERO EL LIBRO
      if (event == 1) {
        this.showAddressBook = true;
        if(this.selectedSchedule.addressBookList.length == 0) {
          this.selectedSchedule.addressBook = null;
          this.selectedSchedule.addressHome = null;
        }
      }

      // NO QUIERO EL LIBRO
      if (event == 0) {

        this.showAddressBook = false;
        this.selectedSchedule.addressBook = null;
        this.selectedSchedule.addressHome = null;
        this.selectedSchedule.district = null;
      }
    },

    async selectAddressBook() {

      // SI SELECCIONO LOCAL
      if (this.selectedSchedule.addressBook.id == 'LOCAL') {
        this.ifSelectHome = false;
        this.selectedSchedule.addressHome = null;
        this.selectedSchedule.district = null;
      }

      // SI SELECCIONO DOMICILIO
      if (this.selectedSchedule.addressBook.id == 'DOMICILIO') {
        this.ifSelectHome = true;

        if (!this.selectedSchedule.listDistrict.length) {
          await this.getDistrict();
        }
      }
    },

    async getDistrict() {
      this.districtLoading = true;

      const res = await axios({
        method: "post",
        url: "form/listar-distrito-por-id-provincia/",
        data: {
          codigo: "131", // Lima
        },
      });

      this.selectedSchedule.listDistrict = res.data.detail;
      this.districtLoading = false;
    },
  },

  watch: {
    setCampus: function(value) {
      this.selectedSchedule.campus = null;
      this.selectedSchedule.modality = null;
      this.selectedSchedule.frequency = null;
      this.selectedSchedule.schedule = null;
      this.selectedSchedule.date = null;
      this.selectedSchedule.section = null;
      this.selectedSchedule.freeDayList = [];
      // this.addPropToDefaultSection({ modality_name: null });
      // this.addPropToDefaultSection({ frequency: null });
      // this.addPropToDefaultSection({ schedule: null });
      // this.addPropToDefaultSection({ start_end_date: null });
      // this.addPropToDefaultSection({ campus_address: null });
      // this.addPropToDefaultSection({ curriculum_id: null });
      // this.addPropToDefaultSection({ other_discounts: null });
      // this.addPropToDefaultSection({ book_purchase: null });
    },
    setModality: function(value) {
      this.selectedSchedule.frequencyList = [];
      this.selectedSchedule.freeDayList = [];
      this.addPropToDefaultSection({ section_id: null });
      this.courseAmount = null;
    },
    setFrequency: function(value) {
      this.courseAmount = null;
      this.selectedSchedule.freeDayList = [];
      this.addPropToDefaultSection({ section_id: null });
      this.selectedSchedule.listSchedules = [];
    },
    setSchedule: function(value) {
      this.courseAmount = null;
      this.selectedSchedule.freeDayList = [];
      this.addPropToDefaultSection({ section_id: null });
      this.selectedSchedule.listOfDates = [];
    },
    setListOfDates: function(value) {
      this.courseAmount = null;
      this.selectedSchedule.freeDayList = [];
      this.addPropToDefaultSection({ section_id: null });
      this.selectedSchedule.sectionList = [];
    },
    setSectionList: function(value) {
      //this.addPropToDefaultSection({section_id: null});
    }
  },

  computed: {
    ...mapState(["secretKeyJwt", "statusCourse", "defaultSection"]),

    showScheduleContinuity() {
      if (
        (this.statusCourse.statusCase2 == this.lastCourse.status ||
          this.statusCourse.statusCase4 == this.lastCourse.status) &&
        this.typeOfSchedule == 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    setCampus() {
      return this.selectedSchedule.campusList.map(campus => {
        return {
          campus_id: campus.campus_id,
          campus_phone: campus.campus_phone,
          campus_name: campus.campus_name,
          campus_address: campus.campus_address
        };
      });
    },
    setModality() {
      return this.selectedSchedule.modalityList.map(modality => {
        return {
          modality_id: modality.modality_id,
          modality_name: modality.modality_name
        };
      });
    },
    setFrequency() {
      return this.selectedSchedule.frequencyList.map(frequency => {
        return {
          frequency_id: frequency.frequency_id,
          modality_name: frequency.frequency_name
        };
      });
    },
    setSchedule() {
      return this.selectedSchedule.listSchedules.map(schedule => {
        return {
          schedule_id: schedule.schedule_id,
          schedule_name: schedule.schedule_name
        };
      });
    },
    setListOfDates() {
      return this.selectedSchedule.listOfDates.map(date => {
        return {
          start_end_date_id: date.start_end_date_id,
          start_end_date_name: date.start_end_date_name
        };
      });
    },
    setSectionList() {
      return this.selectedSchedule.sectionList.map(section => {
        return { section_id: section.section_id, classroom: section.classroom };
      });
    }
  }
};
</script>
